/************
 * Model Class
 * File Name ...: purchaseorders.components.ts
 * Generated By : ianday on 5/12/23
 * Date ........: 5/12/23
 /************/


export interface PurchaseOrderNumbers {
    id: number;
    purchaseOrderNumber: string;
    dateRequested: string;
}

export class PurchaseOrderNumbers {

    constructor() {
        this.id = 0;
        this.purchaseOrderNumber = '';
        this.dateRequested = new Date().toISOString();
    }
}
